<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: 160px;">
    <!-- Spinner tant que client n'est pas chargé -->
    <div *ngIf="!client" class="spinner-container w-100 p-4" style="display: flex; justify-content: center; align-items: center;">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only"></span>
        </div>
    </div>

    <!-- Contenu principal -->
    <div *ngIf="client" class="d-flex flex-column flex-sm-row w-100">
        <!-- Colonne gauche -->
        <div class="left-column d-flex flex-column justify-content-start pe-2 flex-grow-1 gap-3">
            <div class="d-flex align-items-center">
                <h2 class="me-2 mb-0">{{ client.nom_prenom || '--' }}</h2>
                <span data-feather="check" class="large-icon text-success m-1"></span>
            </div>

            <!-- TÉLÉPHONE / WHATSAPP : bouton TOUJOURS affiché -->
            <div class="d-flex align-items-center">
                <button type="button" class="phone-button me-2">
                    <a *ngIf="hasPhone(); else noPhoneIcon"
                       [href]="getWhatsAppLink(client.telephones[0])"
                       target="_blank"
                       class="whatsapp-icon"
                       title="Ouvrir WhatsApp"
                       style="color: rgba(0, 162, 14, 0.9);">
                        <span data-feather="phone" class="phone-icon"></span>
                    </a>
                    <ng-template #noPhoneIcon>
                        <span style="rgba(0, 162, 14, 0.9);">
                            <span data-feather="phone" class="phone-icon"></span>
                        </span>
                    </ng-template>
                </button>
                <span class="phone-number">
                    {{ hasPhone() ? (client.telephones[0].code_pays + ' ' + client.telephones[0].num_tel) : '--' }}
                </span>
            </div>

            <!-- EMAIL : bouton TOUJOURS affiché -->
            <div class="d-flex align-items-center" style="margin-top: 12px;">
                <button type="button" class="email-button me-2">
                    <a *ngIf="hasEmail(); else noEmailIcon"
                       href="mailto:{{ client.emails[0].email }}"
                       target="_blank"
                       class="email"
                       title="Envoyer un mail"
                       style="color: rgba(0, 186, 209, 1);">
                        <span data-feather="mail" class="phone-icon"></span>
                    </a>
                    <ng-template #noEmailIcon>
                        <span style="color:rgba(0, 186, 209, 1);">
                            <span data-feather="mail" class="phone-icon"></span>
                        </span>
                    </ng-template>
                </button>
                <span class="phone-number">
                    {{ hasEmail() ? client.emails[0].email : '--' }}
                </span>
            </div>
        </div>

        <!-- Ligne verticale -->
        <div class="vertical-divider d-none d-sm-block"></div>

        <!-- Colonne droite -->
        <div class="right-column d-flex flex-column justify-content-center align-items-center ps-4 gap-2" style="margin-left: 23px; margin-right: 23px;">
            <p class="mb-1 fw-bold">Identifiant unique</p>
            <span class="phone-number">{{ client.identifiant_unique || '--' }}</span>
        </div>
    </div>
</div>
